<template>
<div>
    <div class="mainC">
        <ul class="list-group MobileHide">
        <li class="list-group-item header" style="margin-bottom: 10px; font-size: 13px;">
        <b-btn v-if="favsT.some(fav => fav.id == leagueId)" v-on:click="removeFavorite({value: leagueId , type: tournament})" style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: leagueId , type: tournament})" style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn>           
         <img :src="tournamentLogo + leagueId" style="width: 22px; margin-right: 5px;">
         {{tournmame}}
         </li>
            <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem; margin: auto; margin-top: 20px; margin-bottom: 20px;" v-if="spinning"></b-spinner>
            <div v-for="(time, j) in matchTimes" :key="j"> 
                <li class="list-group-item header">{{j}}</li>
                <div v-for="game in time" :key="game.id"> 
           <li class="list-group-item game" >
            <div class="row">
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.id }}">
            <div class="row">
            <div class="col-1 bodyElement">
              <p v-if="game.matchStatus.name == 'FT'">{{game.matchStatus.name}}</p>
              <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
              <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
              <p v-else-if="game.matchStatus.name == 'NS'">{{game.matchTime.slice(11,16)}}</p>    
              <p v-else-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>      
              <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>    
              <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>     
              <p v-else-if="game.matchStatus.name == 'CANCL'">CNL</p>  
              <p v-else>{{game.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
                {{game.team1.name}}
            </div>
            <div class="col-2 bodyElement" v-if="game.matchStatus.name == 'NS' || game.matchStatus.name == 'POSTP' || game.matchStatus.name == 'CANCL'" style="font-weight: 600; margin-top: -5px;">
                <img :src="teamLogo + game.team1.id" alt="" style="width: 20px;" > - <img :src="teamLogo + game.team2.id" alt="" style="width: 20px;" >
            </div>
            <div class="col-2 bodyElement" v-else>
                {{game.currentScore}}
            </div>
            <div class="col bodyElement">
                {{game.team2.name}}
            </div>
                </div>
            </router-link>
            <div class="col-1 bodyElement">
            <b-btn v-if="favsTe.some(fav => fav.id === game.id)" v-on:click="removeFavorite({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
        </div>
            </li>   
            </div>    
            </div>
        </ul>
        <ul class="list-group MobileShow">
              <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem; margin: auto; margin-top: 20px; margin-bottom: 20px;" v-if="spinning"></b-spinner>
            <div v-for="(time, j) in matchTimes" :key="j"> 
                <li class="list-group-item header">{{j}}</li>
                <div v-for="game in time" :key="game.id"> 
           <li class="list-group-item game" >
            <div class="row">
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.id }}">
            <div class="row">
            <div class="col-1 bodyElement" style="margin-top: 3.7%;">
              <p v-if="game.matchStatus.name == 'FT'">{{game.matchStatus.name}}</p>
              <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
              <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
              <p v-else-if="game.matchStatus.name == 'NS'">{{game.matchTime.slice(11,16)}}</p>  
              <p v-else-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>      
              <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>    
              <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>     
              <p v-else-if="game.matchStatus.name == 'CANCL'">CNL</p>  
              <p v-else>{{game.matchStatus.name}}</p>  
              </div>
           <div class="col" style="text-align: left; font-size: 14px; margin-top: 4px;">
            <div class="bodyElement" style="margin-bottom: 10px;">
                {{game.team1.name}}
            </div>
            <div class="bodyElement">
                {{game.team2.name}}
            </div>
            </div>
             <div class="col-1" v-if="game.matchStatus.name == 'NS'" style="font-weight: 900; margin-top: 4px;">
                 <div style="margin-bottom: 15px;">
                ? 
                </div>
                 <div>
                ?
                 </div>
            </div>
            <div class="col-1" v-else style="margin-top: 4px;">
                 <div style="margin-bottom: 15px;">
            {{game.currentScore.slice(0,1)}} 
                </div>
                 <div>
            {{game.currentScore.slice(2,3)}}
                 </div>
            </div>
                </div>
            </router-link>
            <div class="col-1 bodyElement" style="margin-top: 4px;">
            <b-btn v-if="favsTe.some(fav => fav.id === game.id)" v-on:click="removeFavorite({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
        </div>
            </li>   
            </div>    
            </div>
        </ul>
    </div>
    <div style="padding-top: 10px; padding-bottom: 10px; text-align: center;">
        <b-btn variant="success" style="width: 200px;" v-on:click="pageCount++, addGames()">Load More</b-btn>
    </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {

  name: 'LeaguePageGames',
  data(){
      return{
            games: [],
            gameId: '11886023',
            leagueId: '',
            spinning: '',
            matchTimes: [],
            pageCount: 1,
            match: 'match',
            cookiesObject: '',
            tournament: 'tournament',
            teamLogo: 'https://sportapi.zuniac.com/team/logo/',
            tournamentLogo: 'https://sportapi.zuniac.com/tournament/logo/',
            tournmame: '',
      }
  },
  async created(){
    this.leagueId = this.$route.params.leagueId;

    this.spinning = true;    

    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    var offset = new Date().getTimezoneOffset();
    
    
    if (cookiesObject.token) {
        var res = await fetch(this.httpReq + '/tournament/matches?langId='+ this.cookiesObject.langId  +'&page=1&portalId='+ this.cookiesObject.portalId +'&timezone=%2B'+ offset/-60 +'%3A00&token=' + cookiesObject.token + '&tournamentId=' + this.leagueId);
        var data = await res.json();
        this.games = data.matches;
        this.tournmame = data.tournament.name;

        if (data.code == 200) {
       //everything is okay
    }
    else if (data.code == 401) {
      alert('Not Authorized, need to re sign in!')
         document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else if(data.code == 404){
        alert('Token is not valid and portal id not provided')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
    else if(data.code == 500){
        alert('Server side error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else {
        alert('service error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }

    } else {
        var resp = await fetch(this.httpReq + '/tournament/matches?langId='+ this.cookiesObject.langId  +'&page=1&portalId='+ this.cookiesObject.portalId +'&timezone=%2B'+ offset/-60 +'%3A00&tournamentId=' + this.leagueId);
        var datas = await resp.json();
        this.games = datas.matches;
        this.tournmame = data.tournament.name;
    }

    


    const times = {};
    this.games.forEach((e) => {
        const date = e.matchTime.split(" ")[0];
        
        if(typeof times[date] === 'undefined') {
            times[date] = [];
        }

        times[date].push(e);
    });
    
    this.matchTimes = times;

    this.spinning = false;    

  },
    methods:{
      ...mapActions(["removeFavorite", "addToFavorites"]),
        getDate(){
            var dateObj = new Date();
            var month = dateObj.getUTCMonth() + 1; 
            var monthd = "0"+month;
            var day = dateObj.getUTCDate();
            var year = dateObj.getUTCFullYear();

            var newdate = year + "-" + monthd + "-" + day;

            return newdate;
        },
        addGames(){
            fetch(this.httpReq + '/tournament/matches?page='+ this.pageCount +'&portalId='+ this.cookiesObject.portalId +'&timezone=%2B04%3A00&tournamentId=' + this.leagueId)
            .then((res) => res.json())
            .then((data) => {
                const times = this.matchTimes;
                data.matches.forEach((e) => {
                    const date = e.matchTime.split(" ")[0];
                    
                    if(typeof times[date] === 'undefined') {
                        times[date] = [];
                    }

                    times[date].push(e);
                });
                this.matchTimes = times;
                this.$forceUpdate();
            })
            .catch((err) => { console.log(err); });
        },
        calculateMinutes(value){
        if (value == null) {
            return 'LIVE';
        } else{

        var startDate = new Date(value.replace(' ', 'T'));
        var endDate   =  Date.now();
        var difference = ((endDate - startDate) / 1000) / 60;

        if (difference < 0) {
            difference = difference + 240;
        }

        return parseInt(difference);
        }
         },
    },  
  components: {
  },
  props: {
    
  },
  computed: {
      ...mapGetters(['favsTe', 'favsT', 'httpReq']),
  },
}

</script>

<style scoped>
.mainC{
    margin-top: 2px;
}

#router-link{
    color: black;
    text-decoration: none;
}

.container{
    margin-top: 12px;
}

li{
   line-height:5px;
   border-radius: 0px !important;
   font-size: 12px;
}
.LeagueName{
    margin-bottom: 10px;
}

.header{
    background: #d6d6d6;
    color: black;
}

.bodyElement{
    padding: 0;
    height: 8px;
}

.game{
    text-align: center;
}
.game :hover{
    color: #309a3d;
}

@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
